// todo passer par le store pour récupérer les stats

export const navigationRoutes = {
  root: {
    name: "/",
    displayName: "navigationRoutes.home"
  },
  routes: [
    {
      name: "dashboard-category",
      displayName: "Entreprises",
      requiredRight: ["poissonneries"],
      meta: {
        iconClass: "vuestic-iconset-dashboard"
      },
      disabled: true,
      children: [
        {
          name: "dashboard",
          displayName:
            "Toutes entreprises (@statEntreprises.nbentreprise_active@)"
        },
        {
          name: "dashboardccn",
          params: { ccn: "ccn" },
          displayName: "CCN (@statEntreprises.ccn_active@)"
        },
        {
          name: "dashboardccn",
          params: { ccn: "hors-ccn" },
          displayName:
            "Entreprises hors CCN (@statEntreprises.hors_ccn_active@)"
        },
        {
          name: "dashboardccn",
          params: { ccn: "ccn-inconnue" },
          displayName:
            "Sans CCN identifiée (@statEntreprises.ccn_inconnue_active@)"
        },
        {
          name: "dashboardverif",
          params: { verif: "non-verifie" },
          displayName: "Fiches non vérifiées (@statEntreprises.nbNoVerif@)"
        },
        {
          name: "dashboardverif",
          params: { verif: "expiree" },
          displayName: "Fiches expirées (@statEntreprises.nbVerifExp@)"
        },
        {
          name: "dashboardliquid",
          params: { liquidation: "liquidation" },
          displayName:
            "Entreprises en liquidation (@statEntreprises.nbliquidation@)"
        }
      ]
    },
    {
      name: "adherents",
      displayName: "Adhérents",
      requiredRight: ["adherents"],
      meta: {
        iconClass: "vuestic-iconset-graph"
      },
      disabled: true,
      children: [
        {
          name: "adherents-unpf",
          requiredRight: ["unpf"],
          displayName: "UNPF"
        },
        {
          name: "adherents-spef",
          requiredRight: ["spef"],
          displayName: "SPEF"
        },
        {
          name: "adherents-opef",
          requiredRight: ["unpf", "spef"],
          displayName: "OPEF"
        },
        {
          name: "adherents-autres",
          params: { nomadhesion: "scapp" },
          displayName: "SCAPP"
        },
        {
          name: "adherents-autres",
          params: { nomadhesion: "opam-b" },
          displayName: "OPAM-B"
        },
        {
          name: "adherents-autres",
          params: { nomadhesion: "agromer" },
          displayName: "AGROMER"
        },
        {
          name: "adherents-autres",
          params: { nomadhesion: "vendee" },
          displayName: "Vendée"
        },
        {
          name: "adherents-autres",
          params: { nomadhesion: "languedoc-roussillon" },
          displayName: "Languedoc-Roussillon"
        },
        {
          name: "adherents-autres",
          params: { nomadhesion: "sdep" },
          displayName: "S.D.E.P."
        }
      ]
    },

    {
      name: "other-adhesions",
      requiredRight: ["adhesions_tierces"],
      displayName: "Adhésions Tierces",
      meta: {
        iconSet: "sidebar-menu-item-icon fa",
        iconClass: "fa-archive"
      },
      disabled: true,
      children: [
        {
          name: "gestion-other-adhesions",
          displayName: "Gestion des adhésions",
          requiredRight: ["adhesions_tierces"]
        },
        {
          name: "adherents-other-adhesions",
          displayName: "Gestion des adhérents",
          requiredRight: ["adhesions_tierces"]
        }
      ]
    },
    {
      name: "partenaires",
      requiredRight: ["partenaires"],
      displayName: "Partenaires",
      meta: {
        iconClass: "vuestic-iconset-statistics"
      },
      disabled: true,
      children: [
        {
          name: "contacts",
          params: { listtype: "personnes" },
          requiredRight: [],
          displayName: "Contacts"
        }
      ]
    },
    {
      name: "campaigns",
      requiredRight: ["campagnes"],
      displayName: "Campagne adhésion",
      meta: {
        iconClass: "vuestic-iconset-forms"
      },
      disabled: true,
      children: [
        {
          name: "campaign-unpf",
          requiredRight: ["campagnes_unpf"],
          displayName: "UNPF"
        },
        {
          name: "campaign-spef",
          requiredRight: ["campagnes_spef"],
          displayName: "SPEF"
        },
        {
          name: "campaign-norelance",
          requiredRight: [],
          displayName: "Ne pas relancer"
        }
      ]
    },
    {
      name: "communication",
      requiredRight: ["communications"],
      displayName: "Communication",
      meta: {
        iconClass: "vuestic-iconset-comments"
      },
      disabled: true,
      children: [
        {
          name: "mapa",
          requiredRight: ["mapa"],
          displayName: "MAPA"
        }
      ]
    },
    {
      name: "journal",
      requiredRight: ["journal"],
      displayName: "Journal",
      meta: {
        iconClass: "vuestic-iconset-files"
      },
      disabled: true,
      children: [
        {
          name: "dashboard-journal",
          params: { listtype: "entreprises" },
          requiredRight: ["journal"],
          displayName: "Liste entreprises"
        },
        {
          name: "dashboard-journal",
          params: { listtype: "partenaires" },
          requiredRight: ["journal"],
          displayName: "Liste partenaires"
        },
        {
          name: "historique-journal",
          requiredRight: ["journal"],
          displayName: "Historique"
        }
      ]
    },
    {
      name: "exports",
      requiredRight: ["exports"],
      displayName: "Exports",
      meta: {
        iconClass: "vuestic-iconset-tables"
      },
      disabled: true,
      children: [
        {
          name: "adherents-export",
          requiredRight: ["exports"],
          displayName: "Adherents"
        },
        {
          name: "emails-export",
          requiredRight: ["exports"],
          displayName: "Emails"
        },
        {
          name: "acota-export",
          requiredRight: ["exports"],
          displayName: "ACOTA"
        }
      ]
    },
    {
      name: "prelevements",
      displayName: "Prélèvements",
      requiredRight: ["prelevements"],
      meta: {
        iconSet: "sidebar-menu-item-icon fa",
        iconClass: "fa-money"
      }
    },
    {
      name: "publications",
      requiredRight: ["publications"],
      displayName: "Gestion des publications",
      meta: {
        iconSet: "sidebar-menu-item-icon fa",
        iconClass: "fa-newspaper-o"
      },

      disabled: true,
      children: [
        {
          name: "liste-publication",
          requiredRight: [],
          displayName: "Numeros"
        },
        {
          name: "annonces",
          requiredRight: [],
          displayName: "Annonces"
        },
        {
          name: "devis",
          requiredRight: [],
          displayName: "Devis"
        },
        {
          name: "factures",
          requiredRight: [],
          displayName: "Factures"
        }
        // {
        //   name: "configuration-annonces",
        //   requiredRight: [],
        //   displayName: "Configuration"
        // },
      ]
    },
	{
		name: "publications_web",
		requiredRight: ["publications"],
		displayName: "Gestion des publications web",
		meta: {
		  iconSet: "sidebar-menu-item-icon fa",
		  iconClass: "fa-desktop"
		},

		disabled: true,
		children: [
		  {
			name: "liste-publication-web",
			requiredRight: [],
			displayName: "Mois"
		  },
		  {
			name: "annonces-web",
			requiredRight: [],
			displayName: "Annonces numérique"
		  },
		  {
			name: "devis-web",
			requiredRight: [],
			displayName: "Devis numérique"
		  },
		  {
			name: "factures-web",
			requiredRight: [],
			displayName: "Factures numérique"
		  }
		  // {
		  //   name: "configuration-annonces",
		  //   requiredRight: [],
		  //   displayName: "Configuration"
		  // },
		]
	  },
    {
      name: "retours",
      displayName: "Gestion des retours",
      requiredRight: ["retours"],
      meta: {
        iconSet: "sidebar-menu-item-icon fa",
        iconClass: "fa-exchange"
      }
    },
    {
		name: "afpf",
		displayName: "AFPF",
		requiredRight: ["afpf"],
		meta: {
		  iconSet: "sidebar-menu-item-icon fa",
		  iconClass: "fa-graduation-cap"
		}, 
		disabled: true,
		children: [
			{
			  name: "liste-formations",
			  requiredRight: ["afpf"],
			  displayName: "Formations"
			},
			{
				name: "entreprises-afpf",
				requiredRight: ["afpf"],
				displayName: "Entreprises"
			},
			{
				name: "settings-afpf",
				requiredRight: ["afpf"],
				displayName: "Paramètres"
			}
		  ]
	  },
    {
      name: "users",
      displayName: "Utilisateurs",
      requiredRight: ["utilisateurs"],
      meta: {
        iconClass: "vuestic-iconset-user"
      }
    },
    {
      name: "users-stats",
      displayName: "Statistiques",
      requiredRight: ["users_statistiques"],
      meta: {
        iconSet: "sidebar-menu-item-icon fa",
        iconClass: "fa-area-chart"
      }
    },
    {
      name: "upload",
      displayName: "UploadDoc",
      requiredRight: ["superAdmin"],
      meta: {
        iconClass: "vuestic-iconset-files"
      }
    }
  ]
};
